import gql from 'graphql-tag';

import dokkioUserFragment from '../fragments/dokkioUserFragment';

export const mutationCreateDokkioUsers = gql`
  mutation createDokkioUsers (
    $dokkioUsers: [DokkioUserInput!]!
  ) {
    createDokkioUsers (
      dokkioUsers: $dokkioUsers
    ) {
      ...dokkioUserFragment
    }
  }
  ${dokkioUserFragment}
`;
export default mutationCreateDokkioUsers;
